import { IDivisasServiceMock } from "@/services";

export const mockDivisasService = (): IDivisasServiceMock => ({
  _fetchAllDivisas: jest.fn(),
});
